import momentTZ from 'moment-timezone';
import moment from 'moment/min/moment-with-locales';
import { TIMEZONE_ESTONIA } from './constants';
import { DATE_FORMAT_DD_MM_YYYY, DATE_FORMAT_DD_MMMM_YYYY, DATE_REQUEST } from './common';

export const canChangeUntil = date => {
  if (!date) {
    return '';
  }
  const timezone = moment.tz.guess();
  const roundTime = momentTZ.tz(date, TIMEZONE_ESTONIA).add(12, 'hours').subtract(1, 'minute');
  return `${momentTZ.tz(roundTime, timezone).format('DD MMM, HH:mm')} GMT`;
};

export const showDate = (date, format = DATE_FORMAT_DD_MMMM_YYYY) => moment(date).format(format);

export const roundStarts = (date, format = 'DD MMM, HH:mm') => {
  if (!date) {
    return '';
  }
  const timezone = moment.tz.guess();
  const roundTime = momentTZ.tz(date, TIMEZONE_ESTONIA).add(12, 'hours');
  return `${momentTZ.tz(roundTime, timezone).format(format)} GMT`;
};

export const prettyDate = (date, format = DATE_FORMAT_DD_MM_YYYY) =>
  date ? moment(date).format(format) : '';

export function getDaysLeft(targetDate) {
  if (!targetDate) return '';

  const now = new Date();
  const target = new Date(targetDate);

  // Clear time part for an accurate day difference
  now.setHours(0, 0, 0, 0);
  target.setHours(0, 0, 0, 0);

  const msInDay = 1000 * 60 * 60 * 24;
  const diff = Math.ceil((target.getTime() - now.getTime()) / msInDay);

  if (diff <= 0) return '';

  return `${diff} day${diff === 1 ? '' : 's'}`;
}

export const DEFAULT_THIS_YEAR_PERIOD = [
  moment().startOf('year').format(DATE_REQUEST),
  moment().format(DATE_REQUEST),
];
